// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".clip-loader-with-blocker{display:block;position:fixed;top:0;left:0;width:100vw;height:100vh;background:rgba(68,85,102,.5333333333);z-index:2}.clip-loader-with-blocker.inactive{display:none}", ""]);
// Exports
module.exports = exports;
